import styled from 'styled-components';

export const CustomTable = styled.table`
	width: 90% !important;
  margin: 0 auto;
`;

export const TableHeader = styled.tr`
	font-family: ${props => props.theme.fontFamily.helveticaNeueBold} !important;
	border-bottom: solid 1px ${props => props.theme.colors.lightGrey} !important;
	font-size: ${props => props.theme.fontSize.tableFont} !important;
  color: #022737;
  width: 100% auto !important;
	td {
		padding: 16px 10px !important;
	}
`;

export const TableRowData = styled.tr`
	border-bottom: solid 1px ${props => props.theme.colors.lightGrey} !important;
	font-size: ${props => props.theme.fontSize.tableFont} !important;
`;

export const TableDisplayData = styled.td`
	padding: 16px 10px !important;
`;
